// pako 3's ESM build exposes named exports only — a default import breaks the webpack bundle.
import { gzip } from "pako";

/**
 * Bodies below this size gain nothing from compression: the gzip header plus the CPU cost
 * outweigh the bytes saved. Report and dropdown requests are well under it; the template
 * save is the case this exists for, since it carries the whole workbook as base64.
 */
export const COMPRESSION_THRESHOLD_BYTES = 32 * 1024;

/**
 * Gzips an already-serialised JSON body when it is large enough to be worth it. Returns null
 * when the body should be sent as-is. The backend decompresses this transparently via
 * ASP.NET Core request decompression, so no endpoint needs to know about it.
 */
export const gzipIfWorthwhile = (serialisedBody: string): Uint8Array | null => {
  // JSON travels as UTF-8, so measure encoded bytes rather than UTF-16 code units.
  const byteLength = new TextEncoder().encode(serialisedBody).length;
  if (byteLength < COMPRESSION_THRESHOLD_BYTES) {
    return null;
  }

  return gzip(serialisedBody);
};
